import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CALENDAR_CONSTANTS, CALENDAR_LINES} from '../constants/calendarConstants';

interface RentalCalendarGroupRowProps extends RequiredTestIdProps {
  label: string;
  vehicleCount: number;
  trackWidth: number;
}

/**
 * Separator drawn in front of each group of vehicles. The label sits in the sticky title column so
 * it stays readable while the timeline scrolls, and the rest of the row is an empty band.
 */
export function RentalCalendarGroupRow(props: RentalCalendarGroupRowProps) {
  return (
    <div
      className="flex bg-palettes-neutral-20-100"
      style={{height: CALENDAR_CONSTANTS.GROUP_ROW_HEIGHT, ...CALENDAR_LINES.rowBottom}}
      data-testid={suffixTestId(`group-${props.label}`, props)}
    >
      <div
        className="sticky left-0 flex shrink-0 items-center gap-2 bg-palettes-neutral-20-100 px-2"
        style={{width: CALENDAR_CONSTANTS.TITLE_COLUMN_WIDTH, ...CALENDAR_LINES.titleCell}}
      >
        <span className="truncate text-xs font-bold uppercase tracking-wide text-secondary">
          {props.label}
        </span>
        <span className="text-xs text-tertiary">{props.vehicleCount}</span>
      </div>
      <div className="shrink-0" style={{width: props.trackWidth}} />
    </div>
  );
}
